import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Grid from '../Base/AntGrid';
import { fetchServer } from '../Base/modelManager';
import { message } from '../Base/Message';
import moment from 'moment/moment';
import { excelExport } from '../Base/ExportExcelAction';
import { Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FilterDateDropDown, FilterDropDown } from '../Base/Filters';
import { DateFilter } from '../Base/FilterInput';






class Factures extends React.Component {
  constructor(props) {
    super(props)

    const actions = [
      {
        id: 'reload',
        icon: <img src="/assets/images/icons/picto_rafraichir.svg" alt="Bootstrap" width="20" height="20" className='gridHeaderImage'/>,
        libelle: 'Recharger',
        onExecute: () => {
          this.handleFetch()
        }
      },
      excelExport(this.props.apiUrl + '/Services/exportConso', 'Conso.xlsx', this.getFilterProcessed, () => '', this.getToken)
    ]


    this.state = {
      data: [],
      columns: [],
      loading: false,
      keyField: 'uid',
      queryColumns: [],
      height: 0,
      quickFilterString: '',
      actions: actions,
      render: true,
      selectedRows: [],
      modal: {
        isOpen: false,
        view: null,
        record: null,
        factureID: null,
        clientid: null
      },
      filters: {
        date: [{ ope: "Between", value1: moment().startOf('month').format('YYYY-MM-DD'), value2: moment().format('YYYY-MM-DD') }],
        utilisateur: null, 
        article: null,
         support: null 
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
      }
    }
  }

  componentDidMount() {
    this.handleFetch()
  }


  getToken = () => {
    return this.props.JWTToken
  }

  getFilterProcessed = () => {
    const { filters } = this.state

    return this.processFilter(filters)
  }

  componentDidUpdate(prevProp) {
    if (prevProp.currentClient !== this.props.currentClient)
      this.handleFetch()
  }
  getModalComponent = () => {

  }

  columns = () => {
    const {filters}=this.state
    const cols = []

    cols.push(


      {
        render: (text, record) => moment(record.date).format('DD/MM/YYYY HH:mm:ss'),
        title: 'Date',
        width: '150px',
        key: 'date',
        filteredValue: filters.date,
        filterDropdown: FilterDateDropDown,
      },
      {
        render: (text, record) => record.support,
        title: 'Support',
        width: '175px',
        key: 'support',
        filteredValue: filters.support,
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <FilterDropDown
            setSelectedKeys={setSelectedKeys}
            selectedKeys={selectedKeys}
            confirm={confirm}
            clearFilters={clearFilters}
          >
            <Form.Control

              placeholder='numero de support contient'
              value={selectedKeys}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8, display: 'block' }}
            />
          </FilterDropDown>
        ),
      },
      {
        title: () => <>Immatriculation<br />Chauffeur</>,
        render: (text, record) => <>{record.immatriculation !== undefined && record.immatriculation !== '' ? <p>{record.immatriculation}</p> : null}
          {record.chauffeur !== undefined && record.chauffeur !== '' ? <p>{record.chauffeur}</p> : null}</>,
        width: '150px',
        key: 'utilisateur',
        filteredValue: filters.utilisateur,
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <FilterDropDown
            setSelectedKeys={setSelectedKeys}
            selectedKeys={selectedKeys}
            confirm={confirm}
            clearFilters={clearFilters}
            
          >
            <Form.Control

              placeholder='immatriculation contient'
              value={selectedKeys}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8, display: 'block' }}
            />
          </FilterDropDown>
        ),
      },

      {
        title: 'Station',
        render: (text, record) => record.adrstation !== undefined ? <> {record.codestation} {record.adrstation}</> : (record.sortienom !== undefined || record.entreenom !== undefined) ? <>{record.entreenom !== 'Gare pouvant representer un systeme ouvert' ? record.entreenom : 'SYSTEM OUVERT'}<br />{record.sortienom}</> : null,
        width: '250px',
        key:'station',
        filteredValue: filters.station,
      },
      {
        title: 'Article',
        render: (text, record) => record.codearti + ':' + record.libearti,
        width: '175px',
        key: 'article',
        filteredValue: filters.article,
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <FilterDropDown
            setSelectedKeys={setSelectedKeys}
            selectedKeys={selectedKeys}
            confirm={confirm}
            clearFilters={clearFilters}
          >
            <Form.Control

              placeholder='Article contient'
              value={selectedKeys}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8, display: 'block' }}
            />
          </FilterDropDown>
        ),
      },

      {
        render: (text, record) => record.txtva,
        title: 'Tx.TVA',
        width: '70px',
        key:'tva',
        filteredValue: filters.tva,
      },
      {

        render: (text, record) => record.qte,
        title: 'Qte.',
        width: '70px',
        key:'qte',
        filteredValue: filters.qte,
      },

      {
        render: (text, record) => record.montantht,
        title: 'HT',
        width: '75px',
        key:'HT',
        filteredValue: filters.HT,
      },
      {
        render: (text, record) => record.montanttva,
        title: 'TVA',
        width: '75px',
        key:'tva',
        filteredValue: filters.tva,
      },
      {
        render: (text, record) => (record.montantht + record.montanttva).toFixed(2),
        title: 'TTC',
        width: '75px',
        key:'ttc',
        filteredValue: filters.ttc,
      },/*
      {
        key: 'actions',
        render: (text, record) => this.actionRenderer(text, record),
        fixed: 'right',
        width: 33 * 5 + 2

      }*/

    )
    return cols
  }

  filterComponent = () => {
    const {pagination,filters}=this.state

    return (
      <DateFilter
        selectedKeys={filters.date}
        showTime={false}
        onChange={value => {
          const newfilters={...filters,date:[value]}
          this.handleFetch(pagination,newfilters)

        }}

      />
    )

  }

  render() {



    return (
      <>
        {this.getModalComponent()}
        <Grid
          Grid
          data={this.state.data}
          columns={this.columns()}
          pagination={this.state.pagination}
          loading={this.state.loading}
          keyField='uid'
          handleFetch={this.handleFetch}
          actions={this.state.actions}
          title="- MES TRANSACTIONS -"
          filterComponent={this.filterComponent}
        />
      </>
    )


  }

  processFilter = (filters) => {

    let filter = ''
    if (filters !== undefined && filters !== null) {
      const keys = Object.keys(filters)


      if (this.props.filter !== undefined) {
        filter = 'client/uid eq ' + this.props.filter.cid
      }

      keys.forEach(key => {
        if (filters[key] !== null) {

          if (key === 'support' && filter[key] !== null) {
            if (filter !== '') filter = filter + ' and '
            filter = filter + 'contains(support,\'' + filters[key] + '\')'
          }
          if (key === 'article' && filter[key] !== null) {
            if (filter !== '') filter = filter + ' and '
            filter = filter + '( contains(codearti,\'' + filters[key] + '\') or contains(libearti,\'' + filters[key] + '\'))'
          }
          if (key === 'utilisateur' && filter[key] !== null) {
            if (filter !== '') filter = filter + ' and '
            filter = filter + '(  contains(immatriculation,\'' + filters[key] + '\') )'
          }
          if (key === 'date' && filter[key] !== null) {
            if (filter !== '') filter = filter + ' and '
            // eslint-disable-next-line
            let debut
            let fin 
            switch (filters[key][0].ope) {
              case 'Between':
                 debut = moment(filters[key][0].value1).format('YYYY-MM-DD')
                 fin = moment(filters[key][0].value2).add(1, 'days').format('YYYY-MM-DD')
                filter = filter + '( date ge \'' + debut + '\' and date lt \'' + fin + '\')'
                break
              case 'eq':
                 debut = moment(filters[key][0].value1).format('YYYY-MM-DD')
                 fin = moment(filters[key][0].value1).add(1, 'days').format('YYYY-MM-DD')
                filter = filter + '( date ge \'' + debut + '\' and date lt \'' + fin + '\')'
                break

                case 'greatereq':
                  debut = moment(filters[key][0].value1).format('YYYY-MM-DD')
                 
                 filter = filter + '( date ge \'' + debut + '\')'
                 break
                case 'greater':
                  debut = moment(filters[key][0].value1).add(1, 'days').format('YYYY-MM-DD')
                  
                 filter = filter + '( date ge \'' + debut + '\')'
                 break
                case 'LesserEq':
                  debut = moment(filters[key][0].value1).add(1, 'days').format('YYYY-MM-DD')
                 filter = filter + '( date lt \'' + debut + '\')'
                 break
                case 'Lesser':
                  debut = moment(filters[key][0].value1).format('YYYY-MM-DD')
                 
                 filter = filter + '( date lt \'' + debut + '\')'
                 break
                 default :
                  break
                 

            }

          }

        }
      })





    }

    if (filter !== '')
      filter = '&$filter=' + filter

    return filter
  }

  onError = (error) => {
    message.error(error)
  }

  actionRenderer = (text, record,) => {


    const actions = []
    actions.push(
      {
        id: 'print',
        icon: <img src="/assets/images/icons/printer.svg" alt="Bootstrap" width="16" height="16" />,
        tooltip: 'Imprimer',
        onExecute: (event, record) => {
          this.printFacture(record.id)
        }
      })

    actions.push(
      {
        id: 'excel',
        icon: <img src="/assets/images/icons/filetype-xlsx.svg" alt="Bootstrap" width="16" height="16" />,
        tooltip: 'Exporter',
        onExecute: (event, record) => {
          this.printFacture(record.id)
        }


      })




    return (
      <span>
        {
          actions.map((action) => {

            const renderTooltip = (props) =>
              <Tooltip id={props.id}>
                {props.tooltip}
              </Tooltip>

            return (
              <OverlayTrigger
                key={action.id}
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip(action)}
              >

                <Button bsPrefix="gridButton" onClick={(event) => { action.onExecute(event) }}> {action.icon}</Button>

              </OverlayTrigger>

            )

          })
        }
      </span>

    )
  }

  handleFetch = (pagination, filters, sorter) => {



    if (this.state.loading === false) {
      this.setState({ loading: true })


      if (pagination === undefined)
        pagination = this.state.pagination


      if (filters === undefined)
        filters = this.state.filters

      if (sorter === undefined)
        sorter = this.state.sorter


      const filter = this.processFilter(filters)

      // filter.page = page;
      // filter.pageSize = this.state.pageSize

      const request = {
        endPoint: this.props.apiUrl + '/TransactionInterface?$orderby=date desc&$top=' + pagination.pageSize + '&$skip=' + pagination.pageSize * (pagination.current - 1) + '&$inlinecount=allpages' + filter,
        method: 'GET',
        token: this.props.JWTToken
      }

      fetchServer(request, (json) => {
        this.setState(({
          loading: false,
          data: json.value,
          pagination: {
            total: json['@xdata.count'],
            current: pagination.current,
            pageSize: pagination.pageSize
          },
          render: true,
          filters: filters

        }))
      }, this.onError)

    }
  }
}


const mapStateToProps = (state) => {
  return ({
    serverConfigLoaded: state.server.initialized,
    clients: state.authentication.clients,
    currentClient: state.authentication.currentClient,
    JWTToken: state.authentication.JWTToken,
    apiUrl: state.server.apiUrl,
  })
}

Factures.propTypes = {
  dispatch: PropTypes.func,
  apiUrl: PropTypes.string,
  clients: PropTypes.array,
  currentClient: PropTypes.object,
  JWTToken: PropTypes.string
};

export default connect(mapStateToProps)(Factures);
